module.exports = __webpack_public_path__ + "static/img/news_50.4f4ee17.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/news_50.jpg
// module id = oNWN
// module chunks = 2